import { StrapiAuthor } from "@/types/strapi";

export const pluralizeAuthorList = (authors?: StrapiAuthor[]) => {
    if (!authors || authors.length === 0) {
        return "Warp Team";
    }

    return new Intl.ListFormat().format(authors.map((_author) => _author.Name));
};
